// assets
import { IconCalendarStats, IconCreditCard, IconListDetails, IconMedal, IconRouteAltLeft } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - DEFINITIONS (DEF-1) ||============================== //
// Tenant reference-data code lists (event types, sponsor tiers, …). Core module — always visible
// (no requiredModule); managed via definitions.manage. Title is a react-intl key [STD-I18N].

const definitions: NavItemType = {
  id: 'definitions',
  title: 'definitions',
  icon: IconListDetails,
  type: 'group',
  children: [
    {
      id: 'definitions-age-categories',
      title: 'definitions-age-categories',
      icon: IconCalendarStats,
      type: 'item',
      url: '/definitions/age-categories',
      module: 'definitions.entries'
    },
    {
      // DEF-SPLIT (mig 318): gated on the NEW `definitions.groups` module, not `definitions.entries`.
      // entries.* is the VALUE read every profile form needs and is now seeded to every role — so
      // gating this item on it lit the admin Definitions screen up for anyone who could fill in a
      // form, including students. Seeing which definition groups exist is its own capability.
      id: 'definitions-groups',
      title: 'definitions-groups',
      icon: IconListDetails,
      type: 'item',
      url: '/definitions/groups',
      module: 'definitions.groups'
    },
    {
      // INST-OPT: taksit sayısı → komisyon oranı. Tablo `commerce` şemasındadır (oran PARA olduğu
      // için planı hesaplayan servis onu çalışma anında okur) — burada olması yalnız gruplamadır,
      // bu yüzden module gate'i commerce.installments'tır, definitions.entries DEĞİL.
      id: 'definitions-installment-options',
      title: 'definitions-installment-options',
      icon: IconCreditCard,
      type: 'item',
      url: '/definitions/installment-options',
      module: 'commerce.installments'
    },
    {
      // OFR-HIER (mig 341): iş ortağı fiyat tekliflerinin geçtiği SIRALI onay rolleri. Tablo `event`
      // şemasındadır — zincir KİMİN ONAYLAYACAĞINA karar verir ve her kararda çalışma anında okunur;
      // definitions şemasını hiçbir servis çalışma anında okuyamaz [STD-OWN]. Yani burada olması
      // yalnız gruplamadır ve module gate'i engagement.offer_chains'tir, definitions.entries DEĞİL —
      // hemen üstteki taksit seçenekleriyle birebir aynı ayrım.
      id: 'definitions-offer-chains',
      title: 'definitions-offer-chains',
      icon: IconRouteAltLeft,
      type: 'item',
      url: '/definitions/offer-chains',
      module: 'engagement.offer_chains'
    },
    {
      // MEDAL (Exam mig 587/588): medal bands by percentile rank. Data in the `exam` schema (the ranking
      // reads attempts there), so the gate is exam.medals — same grouping-only split as the two above.
      id: 'definitions-medal-criteria',
      title: 'definitions-medal-criteria',
      icon: IconMedal,
      type: 'item',
      url: '/definitions/medal-criteria',
      module: 'exam.medals'
    }
  ]
};

export default definitions;
